<template>
  <div class="cr-page-404">
    <div class="cr-container">
      <div class="cr-page-404__title">
        К сожалению, такой страницы не существует. Посмотрите товары, которые у нас есть.
      </div>
      <ProductSlider type="new" title="Новинки"></ProductSlider>
      <ProductSlider type="sale" title="Акции"></ProductSlider>
      <div class="cr-page-404__bottom">
        <a @click="prevPage" class="cr-button cr-button--light">
                        <span class="cr-button__text">
                            Вернуться на страницу назад
                        </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ProductSlider from "@/views/components/ProductSlider.vue";

export default {
  components: {ProductSlider},
  methods: {
    prevPage() {
      this.$router.go(-1)
    },
  }
}
</script>

